import { CreateLabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { VerticalLayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/layout/VerticalLayout";
import { BetData, CurrentPayListEntryContent, SymbolsPayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";
import { SymbolEntryView } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/SymbolEntryView";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Container, Sprite } from "pixi.js";

export class BonusContentView extends BasePaytableComponent {
    override readonly name: string = `bonus-content-view`;

    verticalLayout = new VerticalLayout({ gap: 10 });
    symbolsContainer: Container<Container>;

    constructor(
        protected override services: GameServices,
        symbolsPayout: CurrentPayListEntryContent[],
        protected createLabelText: CreateLabelText,
    ) {
        super(services);

        const { factory } = services;


        const symbolsContainer = new Container<Container>();

        const symbolSprites: Sprite[] = symbolsPayout.map(contentItem => {

            if (contentItem.symbolTexture) {
                const sprite = factory.createSpriteFromTextureKey(contentItem.symbolTexture, {}, symbolsContainer);
                sprite.name = contentItem.symbolTexture;
                return sprite;
            } else if (contentItem.symbolSprite) {
                return services.factory.createSprite(contentItem.symbolSprite, symbolsContainer);
            }

            throw new Error(`Paytable Symbol content missing "symbolTexture" or "symbolSprite"`);
        });

        const maxSymbolHeight = Math.max(...symbolSprites.map(sprite => sprite.height));

        symbolsPayout.forEach((contentItem, index) => {
            const sprite = symbolSprites[index];
            const symbolEntryView = new SymbolEntryView(
                services,
                contentItem.symbolId,
                sprite,
                maxSymbolHeight,
                contentItem.values,
                {},
                false,
                createLabelText
            );
            symbolsContainer.addChild(symbolEntryView);
        });

        symbolsContainer.pivot.x = symbolsContainer.width / 2;
        this.symbolsContainer = symbolsContainer;
        this.verticalLayout.add(symbolsContainer);

        this.verticalLayout.layout(this);
    }

    override updateLayout(width: number, height: number) {
        alignSymbolEntries(this.symbolsContainer, width);
        this.verticalLayout.layout(this);
    }

    override onOpen(betData: BetData): void {
    }
}

export function alignSymbolEntries(container: Container<Container>, screenWidth: number, minItemsPerRow: number = 1, gapBetweenEntries: number = 10) {
    const children = container.children;
    const maxSymbolWidth = Math.max(...children.map((view) => view.getLocalBounds().width));
    const itemsPerRow = Math.max(Math.floor(screenWidth / (maxSymbolWidth + gapBetweenEntries * 2)), minItemsPerRow);
    let posX = 0;
    let posY = 0;
    let currentItem = 0;
    let maxSymbolHeight = 0;
    for (var i = 0; i <= children.length - 1; i++) {
        const view = children[i];
        view.position.x = posX;
        view.position.y = posY;
        posX += maxSymbolWidth + gapBetweenEntries;
        maxSymbolHeight = view.getLocalBounds().height > maxSymbolHeight ? view.getLocalBounds().height : maxSymbolHeight;
        currentItem++;
        if (currentItem >= itemsPerRow) {
            currentItem = 0;
            posX = 0;
            posY += maxSymbolHeight + gapBetweenEntries;
            maxSymbolHeight = 0;
        }
    }
    // center align the last row
    if (children.length / itemsPerRow > 1) {
        const lastRowStartIndex = children.length - (children.length % itemsPerRow);
        if (lastRowStartIndex !== children.length) {
            const pendingItems = children.length - lastRowStartIndex;
            posX = container.width / 2 - ((maxSymbolWidth + gapBetweenEntries) * pendingItems) / 2 + gapBetweenEntries / 2;
            for (var j = lastRowStartIndex; j <= children.length - 1; j++) {
                var view = children[j];
                view.position.x = posX;
                posX += maxSymbolWidth + gapBetweenEntries;
            }
        }
    }
    const localBounds = container.getLocalBounds();
    container.pivot.x = localBounds.x + localBounds.width / 2;
}